<template>
<div >
   
  <b-modal id="modal-center" hide-footer centered title=" ">
    
 
  <form @submit.prevent>
    <h6 class="heading-small text-muted mb-4">Modifier Profile</h6>
   
    <div class="pl-lg-4">
     
       <div class="row">
        <div class="col-lg-6">
          <base-input
            alternative
            label="Nom"
            placeholder="Nom"
            input-classes="form-control-alternative"
            v-model="model.firstName"
          />
        </div>
        <div class="col-lg-6">
          <base-input
            alternative
            label="Prenom"
            placeholder="Prenom"
            input-classes="form-control-alternative"
            v-model="model.lastName"
          />
        </div>
         
        <div class="col-lg-6">
          <base-input
            alternative
            label="Email"
            placeholder="jesse@example.com"
            input-classes="form-control-alternative"
            v-model="model.email"
          />
        </div>
         <div class="col-lg-6">
          <base-input
            alternative
            label="Mot de passe"
            placeholder="Mot de passe"
            input-classes="form-control-alternative"
            v-model="model.password"
          />
        </div>
      </div>
    </div>
    
   
   <hr class="my-4" />
    <!-- Description -->
  <center><b-btn type="submit" style="background-color:#c2b59b;color:#fff" >Modifier</b-btn></center> 
  
  </form>
   </b-modal>
</div>
</template>
<script>
export default {
     name: 'ModalUpdateProfile',
     
    data() {
      return {
        model: {
          password: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          
        }
      }
    },
}
</script>
                        